import { Injectable, NgZone, inject } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly zone = inject(NgZone);

  open(
    message: string,
    action = 'Cerrar',
    config: MatSnackBarConfig = {},
  ): MatSnackBarRef<TextOnlySnackBar> {
    return this.zone.run(() =>
      this.snackBar.open(message, action, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        ...config,
      }),
    );
  }

  success(message: string, config: MatSnackBarConfig = {}): MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, 'Cerrar', {
      duration: 4000,
      ...config,
    });
  }

  error(message: string, config: MatSnackBarConfig = {}): MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, 'Cerrar', {
      duration: 7000,
      panelClass: 'snackbar-error',
      ...config,
    });
  }

  dismiss(): void {
    this.zone.run(() => this.snackBar.dismiss());
  }
}
